import React, { useEffect } from 'react';
import { Box, LinearProgress } from '@material-ui/core';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive';
import MobileTitle from '../../customUI/MobileTitle';
import { storeContext } from '../provider/Provider';
import { ppcActions } from '../../store/ppc-reducer';
import useStyles from './PaidMedia.style';
import PrimaryContainer from '../../customUI/PrimaryContainer';
import logo from '../../images/logo-2.svg';
import steps from '../../images/steps.svg';
import social from '../../images/social.svg';

const { REACT_APP_FLASK_API_URL } = process.env;

const PaidMedia = () => {
  const classes = useStyles();
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  const { state, dispatch } = React.useContext(storeContext);

  useEffect(() => {
    dispatch({
      type: ppcActions.PPC_SET_ALL,
      payload: { isFetching: true },
    });
    axios
      .get(`${REACT_APP_FLASK_API_URL}/v1/analytics/${state.websiteSwitch.currentWebsite}`)
      .then((res) => {
        if (!res.data.error) {
          dispatch({
            type: ppcActions.PPC_SET_ALL,
            payload: {
              ppc_report: res.data.data.ppc_report,
              isFetching: false,
            },
          });
        }
      });
  }, []);

  if (state.ppc.isFetching) {
    return <LinearProgress data-testid="loading-indicator" style={{ width: '100%' }} />
  }

  return (
    <div className={classes.wrapper}>
      {isPhone && <MobileTitle className={classes.mobileTitle} title="Paid Media" />}

      {!state.ppc.ppc_report ? (
        <PrimaryContainer>
          <div style={{ maxWidth: 1000, margin: 'auto' }}>
            <div className={classes.center}>
              <img src={logo} className={classes.topLogo} alt="Hennessey Logo" height="75" />
            </div>
            <p data-testid="paid-media-help" className={classes.heading}>How Can Our Paid Media Team (PPC) Help You?</p>
            <p className={classes.paragraph}>
              Staying on top of changes in technology and trends in how people research and
              consume information can be information overload. And it’s easy to fall behind.
              Hennessey Digital takes that off your shoulders, makes it easy for you to
              understand, and helps you drive leads so that you can focus on clients and
              cases.
            </p>
            <div className={classes.center}>
              <img
                src={steps}
                className={classes.full}
                alt="6 Steps to better SEO"
                height="65"
              />
            </div>
            <p className={classes.paragraph}>
              Our search engine marketing and digital paid media management effectively
              targets and reaches prospective clients by boosting your firm’s visibility in
              places where they are searching or consuming information on mobile and online.
            </p>
            <div className={classes.center}>
              <p className={classes.bigText}>We make it easy for you.</p>
              <img
                src={social}
                className={classes.social}
                alt="Social Services"
                height="250"
              />
            </div>
          </div>
        </PrimaryContainer>
      ) : (
        <Box display='flex' flex={1} flexDirection='column'>
          <Box pb={2}>
            <div className={classes.card}>
              <div className={classes.card__wrapper} style={{ height: '90vh' }}>
                <iframe data-testid='ppc-report-iframe' title='data-studio-desktop' width='100%' style={
                  {
                    display: 'block',
                    position: 'relative',
                    border: 'none',
                  }
                } height='100%' src={state.ppc.ppc_report} />
              </div>
            </div>
          </Box>
        </Box>

      )}
    </div>
  );
};

export default PaidMedia;
